export default function TrashIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0002 1.0415C7.81404 1.0415 6.04183 2.81371 6.04183 4.99984V5.20817H3.3335C2.98832 5.20817 2.7085 5.48799 2.7085 5.83317C2.7085 6.17835 2.98832 6.45817 3.3335 6.45817H16.6668C17.012 6.45817 17.2918 6.17835 17.2918 5.83317C17.2918 5.48799 17.012 5.20817 16.6668 5.20817H13.9585V4.99984C13.9585 2.81371 12.1863 1.0415 10.0002 1.0415ZM10.0002 2.2915C11.4959 2.2915 12.7085 3.50407 12.7085 4.99984V5.20817H7.29183V4.99984C7.29183 3.50407 8.50439 2.2915 10.0002 2.2915Z"
        fill="#64748B"
      />
      <path
        d="M4.78903 7.44072C4.75638 7.09709 4.45134 6.84499 4.10771 6.87764C3.76408 6.91029 3.51198 7.21532 3.54463 7.55895C3.62336 8.38752 3.76543 9.40843 3.94806 10.7207L4.18268 12.4066C4.40699 14.0189 4.5342 14.9333 4.80941 15.6823C5.32158 17.0763 6.23521 18.1939 7.41021 18.6897C8.04827 18.9589 8.7781 18.9587 9.8646 18.9582H10.1357C11.2222 18.9587 11.9521 18.9589 12.5901 18.6897C13.7651 18.1939 14.6787 17.0763 15.1909 15.6823C15.4661 14.9333 15.5933 14.0189 15.8176 12.4066L16.0523 10.7207C16.2349 9.40844 16.377 8.38752 16.4557 7.55896C16.4883 7.21532 16.2362 6.91029 15.8926 6.87764C15.549 6.84499 15.2439 7.09709 15.2113 7.44072C15.1354 8.23902 14.9972 9.23319 14.8121 10.5633L14.5935 12.1341C14.3514 13.8738 14.2405 14.6445 14.0176 15.2512C13.5877 16.4213 12.8728 17.2137 12.1041 17.538C11.729 17.6963 11.2745 17.7082 10.0002 17.7082C8.72586 17.7082 8.27136 17.6963 7.89619 17.538C7.12749 17.2137 6.41263 16.4213 5.98272 15.2512C5.75979 14.6445 5.64892 13.8738 5.40681 12.1341L5.1882 10.5633C5.00309 9.2332 4.86488 8.23903 4.78903 7.44072Z"
        fill="#64748B"
      />
      <path
        d="M8.9585 8.33317C8.9585 7.98799 8.67867 7.70817 8.3335 7.70817C7.98832 7.70817 7.7085 7.98799 7.7085 8.33317V14.9998C7.7085 15.345 7.98832 15.6248 8.3335 15.6248C8.67867 15.6248 8.9585 15.345 8.9585 14.9998V8.33317Z"
        fill="#64748B"
      />
      <path
        d="M12.2918 8.33317C12.2918 7.98799 12.012 7.70817 11.6668 7.70817C11.3217 7.70817 11.0418 7.98799 11.0418 8.33317V14.9998C11.0418 15.345 11.3217 15.6248 11.6668 15.6248C12.012 15.6248 12.2918 15.345 12.2918 14.9998V8.33317Z"
        fill="#64748B"
      />
    </svg>
  );
}
